var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"legal-notice"},[_vm._v("\n  © "+_vm._s(_vm.pageData.year)+" Iconic Group, Inc.\n  "+_vm._s(_vm.pageData.resourceStrings.footerReproductionNotice)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce67e22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/site-footer/components/LegalNotice.vue
// module id = 1763
// module chunks = 27